import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    content:
      'You can only have one active physical card at a time. To be able to order a new one, you will first need to deactivate the',
    contentSuffix: ' card.',
    subtitle: 'Any question?',
    title: "Why can't I order a physical card?",
  },
  fr: {
    content:
      'Vous ne pouvez posséder qu’une carte physique active à la fois. Pour pouvoir en commander une nouvelle, il vous faudra d’abord désactiver la carte',
    contentSuffix: '.',
    subtitle: 'Une question ?',
    title: 'Pourquoi ne puis-je pas commander de carte physique ?',
  },
} as const);

export default locales;
